import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocaleStore } from '@/entities/locale';
import { buildDefaultPageHead } from './config';

export function AppHead() {
  const locale = useLocaleStore((state) => state.locale);
  const head = buildDefaultPageHead(locale);

  useEffect(() => {
    let script = document.head.querySelector<HTMLScriptElement>('script[data-creaticode-site-jsonld="true"]');

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-creaticode-site-jsonld', 'true');
      document.head.appendChild(script);
    }

    script.textContent = head.websiteStructuredData;

    return () => {
      if (script?.parentNode === document.head) {
        document.head.removeChild(script);
      }
    };
  }, [head.websiteStructuredData]);

  return (
    <Helmet>
      <title>{head.title}</title>
      <meta name="author" content={head.author} />
      <meta name="description" content={head.description} />
      <meta name="keywords" content={head.keywords} />
      <link rel="canonical" href={head.canonicalUrl} />
      {head.alternateLinks.map((link) => (
        <link key={link.hrefLang} rel="alternate" href={link.href} hrefLang={link.hrefLang} />
      ))}
      <meta property="og:title" content={head.ogTitle} />
      <meta property="og:description" content={head.ogDescription} />
      <meta property="og:url" content={head.ogUrl} />
      <meta property="og:site_name" content={head.siteName} />
      <meta property="og:image" content={head.ogImage} />
    </Helmet>
  );
}
